import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_MATERIALS':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_MATERIALS':
      return Object.assign({}, state, {
        materialList: action.payload.data,
        loading: action.loading
      })
    case 'TOGGLE_MATERIALS_MODAL':
      return Object.assign({}, state, {
        materialsModal: !state.materialsModal
      })
    default:
      return state
  }
}

export default reducer
